import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import {
  DeleteIcon,
  EditIcon,
  EyeOpened,
  GrayDownloadIcon,
  Invoice,
} from "../../../styled/AllImages";
import { getModuleOperations } from "../../../../utils";

const ActionButtons = ({
  row,
  onEdit,
  onDelete,
  onOpen,
  onDownload,
  onInvoiceDownload,
  onViewDetails,
  onStatusToggle,
  status,
  options,
  typeId,
  onInfoView,
  tooltipData,
  updateVisibilityStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div className="action-buttons">
      {/* {filteredOptions &&
        filteredOptions.includes("open") &&
        getModuleOperations(cabinetTypeId, 3) && (
          <button
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("open")}
            onClick={onOpen}
          >
            {t("open")}
          </button>
        )} */}

      {/* {filteredOptions && filteredOptions.includes("tooltip") && (
        <TooltipInfo data={tooltipData} />
      )}

      {filteredOptions && filteredOptions.includes("tooltip2") && department && (
        <ProfileTooltip
          data={departmentInfo}
          userName={department.userName}
          userRole={department.userRole}
          userImage={department.userImage}
        />
      )} */}

      {options &&
        options.includes("invoice") && (
          <span
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("generate_invoice")}
            onClick={onInvoiceDownload && onInvoiceDownload}
          >
            <Invoice />
          </span>
        )}
      {options &&
        options.includes("view") &&
        getModuleOperations(typeId, 3) && (
          <span
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("view_details")}
            onClick={onOpen && onOpen}
          >
            <EyeOpened />
          </span>
        )}

      {options && options.includes("download") && (
        <span
          className="default-icon"
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("download")}
          onClick={onDownload && onDownload}
        >
          <GrayDownloadIcon />
        </span>
      )}

      {/* {filteredOptions &&
        filteredOptions.includes("info") &&
        getModuleOperations(typeId, 5) && (
          <span
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("history")}
            onClick={() => onInfoView(row)}
          >
            <NewHistoryIcon />
          </span>
        )} */}

      {options &&
        options.includes("edit") &&
        getModuleOperations(typeId, 2) && (
          <span
            // onClick={() => onEdit(row)}
            onClick={onEdit && onEdit}
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("edit")}
          >
            <EditIcon />
          </span>
        )}

      {/* {filteredOptions && filteredOptions.includes("transfer") && (
        <span
          className="default-icon"
          onClick={onTransfer}
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("transfer")}
        >
          <ReverseArrows />
        </span>
      )} */}

      {options && options.includes("status") && (
        <div
          className={`switch ${parseInt(row.active) === 1 ? "active" : ""}`}
          onClick={onStatusToggle && onStatusToggle}
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("status")}
        >
          <span className="slider" />
        </div>
      )}

      {options &&
        options.includes("delete") &&
        getModuleOperations(typeId, 4) && (
          <span
            onClick={onDelete && onDelete}
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("delete")}
          >
            <DeleteIcon />
          </span>
        )}
      <Tooltip
        id="action-tooltip"
        place="top"
        style={{
          backgroundColor: "#333",
          color: "#fff",
          fontSize: "12px",
          borderRadius: "6px",
          padding: "6px 10px",
        }}
      />
    </div>
  );
};

export default ActionButtons;
